import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import moment from "moment";
import MySpinner from "../../components/Spinner/spinner";
import { salesReport, expensesReport, disposingReport, stockingReport, expiringReport, profitReport, itemsStockingReport } from "../../app/reportsSlice";
import { useDispatch, useSelector } from "react-redux";
import AppTabs from "../../components/appTabs/appTabs";
import Sections from "../../components/dashbord/sections";
import { instCat } from "../../common/validators";
import "./reports.css";
import Inputs from "../../components/inputs/Inputs";


const Reports = () => {

  const tabs = instCat() === 4 ? 
  [
    {
      title: "Revenue",
    },
    {
      title: "Others",
    },
  ]
  :
  [
    {
      title: "Revenue",
    },
    {
      title: "Items Expiring",
    },
    {
      title: "Items Stocking",
    },
  ];

  const itemsTableHead = [
    { label: "Period", name: "time_bound" },
    { label: "Amount", name: "amount" }
  ];

  const expiringTableHead = [
    { label: "Item Name", name: "item_description" },
    { label: "Item Code", name: "item_code" },
    { label: "Quantity", name: "qty" },
    { label: "Amount", name: "amount" },
    { label: "Purchase Date", name: "buy_date" },
    { label: "Expiry Date", name: "expiry_date" },
  ];

  const stockedTableHead = [    
    { label: "Entry Date", name: "entry_date" },
    { label: "Item Name", name: "item_description" },
    { label: "Item Code", name: "item_code" },
    { label: "Quantity", name: "qty" },
    { label: "Buy Price", name: "buying_price" },
    { label: "Amount", name: "amount" },
    { label: "Purchase Date", name: "buy_date" },
  ];


  const [activeTab, setActiveTab] = useState(0);
  let [showRevenue, setShowRevenue] = useState(false);
  let [showExpenses, setShowExpenses] = useState(false);
  let [showDisposed, setShowDisposed] = useState(false);
  let [showOther, setShowOther] = useState(false);
  let [hideSaveButton, setHideSaveButton] = useState(false);
  // const [formValues, setFormValues] = useState({});
  const [expiringDataList, setExpiringDataList] = useState([]);
  const [stockDataList, setStockDataList] = useState([]);
  const [errors, setErrors] = useState([]);
  const [formValues, setFormValues] = useState({fromDate: moment().subtract(3,'days').format("YYYY-MM-DD"), toDate: moment().format("YYYY-MM-DD")});
    



  const dispatch = useDispatch();

  const { error: salesError, status: salesStatus, list: salesList } = useSelector(
    ({ reports }) => reports.sales.get
  );

  const { error: expensesError, status: expensesStatus, list: expensesList } = useSelector(
    ({ reports }) => reports.expenses.get
  );

  const { error: disposingError, status: disposingStatus, list: disposingList } = useSelector(
    ({ reports }) => reports.disposing.get
  );

  const { error: stockingError, status: stockingStatus, list: stockingList } = useSelector(
    ({ reports }) => reports.stocking.get
  );

  const { error: itemsStockingError, status: itemsStockingStatus, list: itemsStockingList } = useSelector(
    ({ reports }) => reports.itemsStocking.get
  );

  const { error: expiringError, status: expiringStatus, list: expiringList } = useSelector(
    ({ reports }) => reports.expiring.get
  );

  const { error: profitError, status: profitStatus, list: profitList } = useSelector(
    ({ reports }) => reports.profit.get
  );

  useEffect(() => {
    if (activeTab === 0) {
      setShowRevenue(true);
      setShowDisposed(false);
      setShowOther(false);
      dispatch(salesReport())
      dispatch(expensesReport())
      dispatch(disposingReport())
      dispatch(profitReport())
      dispatch(stockingReport())
    } else if (instCat() != 4 && activeTab === 1) {
      setShowRevenue(false);
      setShowDisposed(true);
      setShowOther(false);
      dispatch(expiringReport())
    } else {
      setShowRevenue(false);
      setShowDisposed(false);
      setShowOther(true);
      dispatch(itemsStockingReport({startDate: moment().subtract(7,'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}))
    }

  }, [dispatch, activeTab]);

  useEffect(() => {
    if(expiringStatus === 'idle' && !expiringError && expiringList){
      let expiringArray = [];
      for (let index = 0; index < expiringList.length; index++) {
        expiringArray.push(
          { item_code: expiringList[index]?.item_code, 
            item_description: expiringList[index]?.item_description,
            qty: Number(expiringList[index]?.qty).toLocaleString(),
            amount: Number(expiringList[index]?.qty * expiringList[index]?.buying_price).toLocaleString(),
            expiry_date: moment(expiringList[index]?.expiry_date).format("YYYY-MM-DD"),
            buy_date: moment(expiringList[index]?.buy_date).format("YYYY-MM-DD"),
          })
        
      }
      setExpiringDataList(expiringArray);

    }
  },[expiringList,expiringStatus,expiringError])

  useEffect(() => {
    if(itemsStockingStatus === 'idle' && !itemsStockingError && itemsStockingList){
      let stockArray = [];
      for (let index = 0; index < itemsStockingList.length; index++) {
        stockArray.push(
          { item_code: itemsStockingList[index]?.item_code, 
            item_description: itemsStockingList[index]?.item_description,
            qty: Number(itemsStockingList[index]?.qty).toLocaleString(),
            buying_price: Number(itemsStockingList[index]?.buying_price).toLocaleString(),
            amount: Number(itemsStockingList[index]?.qty * itemsStockingList[index]?.buying_price).toLocaleString(),
            entry_date: moment(itemsStockingList[index]?.entry_date).format("YYYY-MM-DD"),
            buy_date: moment(itemsStockingList[index]?.buy_date).format("YYYY-MM-DD"),
          })
        
      }
      setStockDataList(stockArray);

    }
  },[itemsStockingList,itemsStockingStatus,itemsStockingError])


  

  const handleRequestClose = () => {

  };

  
    const formOpenSalesSearch = () => {
      return (
        <>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-4">
              <Inputs
                name="fromDate"
                size="small"
                label="Start Date"
                value={formValues.fromDate}
                inputType="date"
                onChange={(e) => {handleChange({ target: { name: "fromDate", value: e } })}}
                error={errors["fromDate"] ? true : false}
                helperText={errors["fromDate"] ? errors.fromDate[0] : null}
              />
            </div>
            <div className="col-sm-12 col-md-6 col-4">
              <Inputs
                name="toDate"
                size="small"
                label="End Date"
                value={formValues.toDate}
                inputType="date"
                onChange={(e) => {handleChange({ target: { name: "toDate", value: e } })}}
                error={errors["toDate"] ? true : false}
                helperText={errors["toDate"] ? errors.toDate[0] : null}
              />
            </div>
            <div className="col-sm-12 col-md-6 col-4">
            <button style={{padding:"15px", borderRadius:"5px"}} onClick={(e)=>{e.preventDefault(); handleSearch()}}>
              Fetch Data
            </button>
            </div>
          </div>
        </>
      )
    }

  const  handleSearch = () => {
    dispatch(itemsStockingReport({startDate: formValues.fromDate, endDate: formValues.toDate}))
  }



  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //toast.success(JSON.stringify(formValues));


  };


  const handleChangeTabs = (index) => {
    setActiveTab(index);
  };


  return (
    <div>
      <div className="ez-page-action">
        <h2 className="page-header">Reports</h2>

      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            Under Maintenance
            {/* <div className="card-body">
              <AppTabs
                tabs={tabs}
                activeTab={activeTab}
                handleTabChange={handleChangeTabs}
              />
              {showRevenue && <div className="row">
                <div className="col-sm-12 col-md-6 col-3 report-sub-div">
                <h4>{instCat() === 4 ? "Transactions" : "Sales"}</h4><br/>
                  {salesList && salesList.length > 0 ? (
                    <Sections
                      columns={itemsTableHead}
                      data={salesList}
                    />
                  ) : showRevenue ? (
                    <MySpinner size={35} color="#367588" />
                  ) : (<></>)}
                </div>
                <div className="col-sm-12 col-md-6 col-3 report-sub-div">
                  <h4>{instCat() === 4 ? "Commissions":"Profit"}</h4><br/>
                  {profitList && profitList.length > 0 ? (
                    <Sections
                      columns={itemsTableHead}
                      data={profitList}
                    />
                  ) : showRevenue ? (
                    <MySpinner size={35} color="#367588" />
                  ) : (<></>)}
                </div>
                <div className="col-sm-12 col-md-6 col-3 report-sub-div">
                <h4>Expenses</h4><br/>
                  {expensesList && expensesList.length > 0 ? (
                    <Sections
                      columns={itemsTableHead}
                      data={expensesList}
                    />
                  ) : showRevenue ? (
                    <MySpinner size={35} color="#367588" />
                  ) : (<></>)}
                </div>
                {
                  instCat() != 4 && instCat() != 5 && (
                    <div className="col-sm-12 col-md-6 col-3 report-sub-div">
                <h4>{instCat() === 4 ? "Float Decreasing":"Disposing"}</h4><br/>
                  {disposingList && disposingList.length > 0 ? (
                    <Sections
                      columns={itemsTableHead}
                      data={disposingList}
                    />
                  ) : showRevenue ? (
                    <MySpinner size={35} color="#367588" />
                  ) : (<></>)}
                </div>
                  )
                }
                
                <div className="col-sm-12 col-md-6 col-3 report-sub-div">
                  <h4>{instCat() === 4 ? "Float Taking":"Stocking"}</h4><br/>
                  {stockingList && stockingList.length > 0 ? (
                    <Sections
                      columns={itemsTableHead}
                      data={stockingList}
                    />
                  ) : showRevenue ? (
                    <MySpinner size={35} color="#367588" />
                  ) : (<></>)}
                </div>

                
              </div>}
              {instCat() != 5 && showDisposed && <div className="row">
                <div className="col-sm-12 col-md-12 col-12 report-sub-div">
                <Table
                columns={expiringTableHead}
                data={expiringDataList}
                downloadFileName={"Items Expiring Soon"}
              />
                </div>
              </div>}

              {showOther && <div className="row">
                <div className="col-sm-12 col-md-12 col-12 report-sub-div">
                  {
                    formOpenSalesSearch()
                  }
                <Table
                columns={stockedTableHead}
                data={stockDataList}
                downloadFileName={"Items Expiring Soon"}
              />
                </div>
                
              </div>}

            </div> */}
          </div>
        </div>
      </div>

    </div>
  );
};

export default Reports;
